__turbopack_context__.v({
  "eyebrow": "SeoServicesCardSection-module__XVDrEW__eyebrow",
  "heading": "SeoServicesCardSection-module__XVDrEW__heading",
  "section": "SeoServicesCardSection-module__XVDrEW__section",
  "title": "SeoServicesCardSection-module__XVDrEW__title",
});
